import { Component } from '@angular/core';
import { Page } from '../../../models/page.model';
import { Role } from '../../../models/role.model';
import { ModalsService } from '../../../services/modals.service';
import { RoleService } from '../../../services/role.service';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { UserService } from '../../../services/user.service';
import { AuthUser } from '../../../models/auth-user.model';
import { HttpParams } from '@angular/common/http';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/public_api';
import { RoleSearchRequest } from '../role-search/role-search.component';
import { AbstractListComponent } from '../../../shared/components/abstract-list/abstract-list.component';
import { SortParam } from '../../../shared/components/sort-toggle/sort-toggle.component';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html'
})
export class RoleListComponent extends AbstractListComponent<Role, RoleSearchRequest> {

  currentUser: AuthUser;

  readonly defaultSort: SortParam = { paramName: 'descr', sortDirection: 'ASC'};

  constructor(
    private roleService: RoleService,
    private userService: UserService,
    private route: ActivatedRoute,
    private modalService: ModalsService
  ) {
    super();
    this.sortParams = this.defaultSort;
    this.userService.currentUser.subscribe(res => {
      this.currentUser = Object.assign(new AuthUser(), res);
    });
    this.route.data.subscribe(data => {
      this.listItems = data.roleListResolverResponse;
    });
  }

  deleteRole(roleId, index) {
    const modalConfig = {
      title: 'ROLES.REMOVE_MODAL.TITLE',
      message: 'ROLES.REMOVE_MODAL.MESSAGE'
    };

    this.modalService.show(ConfirmModalComponent, null, null, 'modal-md', modalConfig).observable.subscribe(() => {
      this.roleService.deleteRole(roleId).subscribe(res => {
        this.onDeletePageItem();
      });
    });
  }

  protected getListItems(params: HttpParams) {
    this.roleService.getRoleList(params).subscribe(res => {
      this.listItems = res;
    });
  }
}
